export default __webpack_public_path__ + "static/media/018-cider.c89cb9da.svg";